import {Component, OnInit} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {AppSettingsService} from '../../../services/app-settings.service';
import {Scenario, StaticMethods, UploadInfo} from '../../../model/GeneralModels';
import {PetRequest, PetScenario} from '../../../model/PetModel';
import {PetService} from '../../../services/pet.service';
import {FileService} from '../../../services/file.service';
import {MatDialog} from '@angular/material/dialog';
import {IntroductionLetterFormComponent} from '../../../Dialogs/introduction-letter-form/introduction-letter-form.component';
import {VisitTypeDialogComponent} from '../../../Dialogs/visit-type-dialog/visit-type-dialog.component';
import {ReservationDialogComponent} from '../../../Dialogs/reservation-dialog/reservation-dialog.component';

@Component({
  selector: 'app-details',
  templateUrl: './details.component.html',
  styleUrls: [
    '../../../assets/vendor/mdi-font/css/material-design-iconic-font.min.css',
    '../../../assets/Content/src/css/lib.vendor.css',
    '../../../assets/Content/src/css/lib.picker.css',
    '../../../assets/Content/src/css/ini.bime.css',
    '../../../assets/vendor/font-awesome-4.7/css/font-awesome.min.css',
    '../../../assets/css/light.theme.css'
  ]
})
export class DetailsComponent implements OnInit {
  requestID: number;
  requestInfo: PetRequest[] = [];
  translation: any = {};
  buttonLabel: string;
  paymentMode: boolean;
  productName = 'PET';
  fileInfo: UploadInfo;
  icon: string = null;

  constructor(
    private activatedRoute: ActivatedRoute,
    public settings: AppSettingsService,
    private service: PetService,
    private router: Router,
    private fileService: FileService,
    public dialog: MatDialog
  ) {
  }

  ngOnInit(): void {
    if (StaticMethods.checkState(this.router, 'requestID', `/${this.productName}/requests`)) {
      this.requestID = history.state.requestID;
      this.getRequestInfo();
    }
  }

  takeAction() {
    const step = this.requestInfo[0].currentStep;
    switch (step) {
      case PetScenario.formSubmitted:
        StaticMethods.fillForms(this.router, this.productName, this.requestID, 'pet_icon');
        break;
      case PetScenario.BirthCertificate:
        this.fileInfo = this.requestInfo[0].getFileInfo();
        break;
      case PetScenario.testUploaded:
        this.fileInfo = this.requestInfo[0].getFileInfo();
        break;
      case PetScenario.visitTypeSelected:
        this.selectVisitType();
        break;
      case PetScenario.paid:
        this.router.navigate([`/invoice/PET/${this.requestID}`]);
        break;
      case PetScenario.visitSessionBooked:
        this.bookSession();
        break;
      case PetScenario.insuranceReleased:
        this.download();
    }
  }

  setButton() {
    const step = this.requestInfo[0].currentStep;
    switch (step) {
      case PetScenario.insuranceReleased:
        this.buttonLabel = 'دانلود بیمه نامه';
        break;
      case PetScenario.visitSessionBooked:
        this.buttonLabel = 'گرفتن نوبت ویزیت';
        break;
      case PetScenario.paid:
        this.buttonLabel = 'پرداخت حق بیمه';
        break;
      case PetScenario.visitTypeSelected:
        this.buttonLabel = 'انتخاب نوع ویزیت';
        break;
      case PetScenario.testUploaded:
        this.buttonLabel = 'اپلود ' + this.requestInfo[0].getFileInfo().persianName;
        break;
      case PetScenario.BirthCertificate:
        this.buttonLabel = 'اپلود ' + this.requestInfo[0].getFileInfo().persianName;
        break;
      case PetScenario.formSubmitted:
        this.buttonLabel = 'تکمیل اطلاعات';
        break;
      case PetScenario.waitingForVetReply:
        this.buttonLabel = null;
        break;
      case PetScenario.waitingForRelease:
        this.buttonLabel = null;
        break;
      default:
        console.log('step not supported: ', step);
    }
  }

  hideFinance() {
    this.paymentMode = false;
  }

  getRequestInfo() {
    this.service.getRequestInfo(this.requestID).subscribe(response => {
      if (response.success) {
        this.translation = StaticMethods.appendTranslation(response.translation, this.translation);
        this.requestInfo = [
          new PetRequest(response.data, PetScenario.generalScenario)
        ];
        this.setButton();
      }
    }, error => {
      this.router.navigate([`/${this.productName}/requests`]);
    });
  }

  hideUploadPanel() {
    this.fileInfo = null;
    this.getRequestInfo();
  }

  private selectVisitType() {
    const dialogRef = this.dialog.open(VisitTypeDialogComponent, {
      width: '350px',
      data: {
        requestID: this.requestID
      }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.getRequestInfo();
      }
    });
  }

  private bookSession() {
    const dref = this.dialog.open(ReservationDialogComponent, {
      data: {
        requestID: this.requestID
      }
    });

    dref.afterClosed().subscribe(result => {
      if (result) {
        this.getRequestInfo();
      }
    });
  }

  private download() {
    this.fileService.downloadReleased(this.requestID, this.productName).subscribe(response => {
      if (response.success) {
        StaticMethods.goToLink(response.data.directLink);
      }
    });
  }
}
